const ForgotPassword = () => import(/* webpackChunkName: "password" */ './forgot-password.vue');

export const ROUTE_NAME_PASSWORD = {
    FORGOT: 'ForgotPassword'
} as const;

export default [
    {
        path: '/forgot-password',
        name: ROUTE_NAME_PASSWORD.FORGOT,
        component: ForgotPassword,
        meta: { requiresUnauth: true }
    }
];
